import { Link } from 'react-router-dom';

import { LanguageSwitcher } from '@/components/TrackingDetail';

const TrackHeader = () => {
  return (
    <header className='sticky top-0 z-50 w-full shrink-0 bg-banner shadow-md'>
      <div className='mx-auto flex w-full max-w-[1400px] items-center justify-between px-6 py-4 sm:px-10 sm:py-5'>
        <Link className='transition-opacity hover:opacity-90' to='/'>
          <img
            alt='Intertrace'
            className='h-6 w-auto sm:h-7'
            src='/images/intertrace-logo-full.png'
          />
        </Link>
        <LanguageSwitcher variant='header' />
      </div>
    </header>
  );
};

export { TrackHeader };
